/* 🤖 this file was generated by svg-to-ts */
export const sbIconsChevronDown: {
  name: 'chevron-down';
  data: string;
} = {
  name: 'chevron-down',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14"><path fill="currentColor" d="M12.6633 4.14541a1.13839 1.13839 0 0 0-1.6051 0L6.97154 8.17516 2.94179 4.14541a1.13837 1.13837 0 0 0-1.60507 0A1.1385 1.1385 0 0 0 1 4.95364a1.13845 1.13845 0 0 0 .33672.80823l4.82659 4.82663c.10583.1067.23173.1913.37045.2491s.28751.0876.43778.0876.29906-.0298.43778-.0876a1.138 1.138 0 0 0 .37045-.2491l4.88353-4.82663a1.139 1.139 0 0 0 .2492-.37045A1.14 1.14 0 0 0 13 4.95364c0-.15027-.0298-.29906-.0875-.43778a1.139 1.139 0 0 0-.2492-.37045"/></svg>`
};
